import { identity } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFilterValueText } from '../../../utils/helpers/filters'
import DateFilter from '../../../components/filter/DateFilter'
import FilterLink from '../../../components/filter/FilterLink'
import FilterSideModal from '../../../components/filter/FilterSideModal'

const DatesFilter = ({ label, field, icon, full, presentation, recommendedOptions, ...props }) => {
  const { t } = useTranslation('processes')
  const [open, setOpen] = React.useState(false)

  const insertedAt = useFilterValueText('insertedAt')
  const scheduling = useFilterValueText('scheduling')
  const endDate = useFilterValueText('endDate')
  const selectedFilters = [insertedAt, scheduling, endDate].filter(identity)
  const filterCount = selectedFilters.length

  let selectedValue = filterCount > 1 && t('processes.dates.multiple', { count: filterCount })
  if (!selectedValue) selectedValue = selectedFilters[0]

  return (
    <>
      <FilterLink
        icon="RiCalendarEventFill"
        label={t('processes.dates.title')}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={t('processes.dates.title')}
        renderOptions={() => (
          <>
            <DateFilter
              label={t('processes.dates.opening')}
              field="insertedAt"
              presentation="list"
              isSelected={!!insertedAt}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('processes.dates.scheduling')}
              field="scheduling"
              presentation="list"
              isSelected={!!scheduling}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('processes.dates.completion')}
              field="endDate"
              presentation="list"
              isSelected={!!endDate}
              recommendedOptions={recommendedOptions}
            />
          </>
        )}
      />
    </>
  )
}

export default DatesFilter
